import React from "react";

import { Tabs, Spin } from "antd";
import FirmUser from "./FirmUser";
import FirmParameter from "./FirmParameter";
import PaymentSet from "./PaymentSet";
const { TabPane } = Tabs;

const FirmPanel = () => {
  return (
    <>
      <Spin spinning={false}>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Cari Kullanıcıları" key="1">
            <FirmUser />
          </TabPane>
          <TabPane tab="Ödeme Setleri" key="2">
            <PaymentSet />
          </TabPane>
          <TabPane tab="Cari Tanımları" key="3">
            <FirmParameter />
          </TabPane>
        </Tabs>
      </Spin>
    </>
  );
};

export default FirmPanel;
